"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.activationReviewNaturalDisasterReducer = exports.activationReviewNaturalDisasterActions = exports.TYPES = void 0;
var _CodeConsts = require("01_core/constants/CodeConsts");
var _reduxActions = require("redux-actions");
var _Consts = require("../common/consts/Consts");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// アクションタイプの接頭辞
const PREFIX = _Consts.CONSTS.COMMON_ACTION_PREFIX + 'activationReviewNaturalDisaster';

// 初期状態
const INIT_STATE = {
  selectSiteKindCd: '',
  searchConditions: {
    [_CodeConsts.CODE.SITE_KIND_CD.CODE_EQ]: {
      bcmKaishaSoshikiCd: '',
      kaishaSoshikiLabel: '',
      kaishaCd: '',
      soshikiCd: ''
    },
    [_CodeConsts.CODE.SITE_KIND_CD.CODE_RH]: {
      targetCd: '',
      targetList: [],
      bcmKaishaSoshikiCd: '',
      kaishaSoshikiLabel: '',
      kaishaCd: '',
      soshikiCd: ''
    }
  },
  searchResult: {
    [_CodeConsts.CODE.SITE_KIND_CD.CODE_EQ]: {
      headerList: [],
      rowList: []
    },
    [_CodeConsts.CODE.SITE_KIND_CD.CODE_RH]: {
      headerList: [],
      rowList: []
    }
  },
  paging: {
    [_CodeConsts.CODE.SITE_KIND_CD.CODE_EQ]: {
      viewNum: 50,
      currentPage: 0
    },
    [_CodeConsts.CODE.SITE_KIND_CD.CODE_RH]: {
      viewNum: 50,
      currentPage: 0
    }
  },
  showDetail: {
    [_CodeConsts.CODE.SITE_KIND_CD.CODE_EQ]: false,
    [_CodeConsts.CODE.SITE_KIND_CD.CODE_RH]: false
  }
};

// アクションタイプ
const TYPES = exports.TYPES = {
  // 初期表示処理
  INIT_DISPLAY: PREFIX + 'InitDisplay',
  // 検索条件変更
  CHANGE_SEARCH_CONDITION: PREFIX + 'ChangeSearchCondtion',
  // 検索結果一覧設定
  SET_SEARCH_RESULT: PREFIX + 'SetSearchResult',
  // ドキュメントアップロード／削除設定
  SET_DOCUMENT_UPLOAD_DELETE: PREFIX + 'DocumentUploadDelete',
  // ページ変更
  CHANGE_PAGE: PREFIX + 'ChangePage',
  // １ページの表示件数を変更
  CHANGE_VIEW_NUM: PREFIX + 'ChangeViewNum',
  // 詳細表示
  CHANGE_SHOW_DETAIL: PREFIX + 'ChangeShowDetail',
  // 初期状態にする
  CLEAR: PREFIX + 'Clear'
};

// アクション
const activationReviewNaturalDisasterActions = exports.activationReviewNaturalDisasterActions = (0, _reduxActions.createActions)({
  // 初期表示処理
  [TYPES.INIT_DISPLAY]: function () {
    return {
      selectSiteKindCd: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  // 検索条件変更
  [TYPES.CHANGE_SEARCH_CONDITION]: function () {
    return {
      key: arguments.length <= 0 ? undefined : arguments[0],
      value: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  // 検索結果一覧設定
  [TYPES.SET_SEARCH_RESULT]: function () {
    return {
      searchResult: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  // ドキュメントアップロード／削除時変更
  [TYPES.SET_DOCUMENT_UPLOAD_DELETE]: function () {
    return {
      searchResult: arguments.length <= 0 ? undefined : arguments[0],
      documentObj: arguments.length <= 1 ? undefined : arguments[1],
      targetData: arguments.length <= 2 ? undefined : arguments[2],
      documentKindCd: arguments.length <= 3 ? undefined : arguments[3]
    };
  },
  // ページ変更
  [TYPES.CHANGE_PAGE]: function () {
    return {
      currentPage: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  // １ページの表示件数を変更
  [TYPES.CHANGE_VIEW_NUM]: function () {
    return {
      viewNum: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  // 詳細表示
  [TYPES.CHANGE_SHOW_DETAIL]: function () {
    return {
      showDetail: arguments.length <= 0 ? undefined : arguments[0],
      searchResult: arguments.length <= 1 ? undefined : arguments[1]
    };
  }
},
// 初期状態にする
TYPES.CLEAR);

// アクション作成
const activationReviewNaturalDisasterReducer = exports.activationReviewNaturalDisasterReducer = (0, _reduxActions.handleActions)({
  // 初期表示処理
  [TYPES.INIT_DISPLAY]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      selectSiteKindCd: action.payload.selectSiteKindCd
    });
  },
  // 検索条件変更
  [TYPES.CHANGE_SEARCH_CONDITION]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    searchConditions: _objectSpread(_objectSpread({}, state.searchConditions), {}, {
      [state.selectSiteKindCd]: _objectSpread(_objectSpread({}, state.searchConditions[state.selectSiteKindCd]), {}, {
        [action.payload.key]: action.payload.value
      })
    })
  }),
  // 検索結果一覧設定
  [TYPES.SET_SEARCH_RESULT]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      searchResult: _objectSpread(_objectSpread({}, state.searchResult), {}, {
        [state.selectSiteKindCd]: {
          headerList: action.payload.searchResult.headerList,
          rowList: action.payload.searchResult.rowList
        }
      }),
      paging: _objectSpread(_objectSpread({}, state.paging), {}, {
        [state.selectSiteKindCd]: _objectSpread({}, INIT_STATE.paging[state.selectSiteKindCd])
      })
    });
  },
  // ドキュメントアップロード／削除設定
  [TYPES.SET_DOCUMENT_UPLOAD_DELETE]: (state, action) => {
    const targetData = action.payload.targetData;
    const documentObj = action.payload.documentObj;
    let rowList = action.payload.searchResult.rowList;
    let newRowList = JSON.parse(JSON.stringify(rowList)).map(row => {
      if (row.bcmKaishaSoshikiCd === targetData.bcmKaishaSoshikiCd && row.bcpTgtJigyoCd === targetData.bcpTgtJigyoCd && row.targetCd === targetData.targetCd) {
        let newFileList = JSON.parse(JSON.stringify(row.documentFileInfoList)).map(fileInfo => {
          if (fileInfo.documentKindCd === action.payload.documentKindCd) {
            fileInfo.fileNm = documentObj.fileNm;
            fileInfo.note = documentObj.note;
            fileInfo.updDt = documentObj.updDt;
          }
          return fileInfo;
        });
        row.documentFileInfoList = newFileList;
      }
      return row;
    });
    return _objectSpread(_objectSpread({}, state), {}, {
      searchResult: _objectSpread(_objectSpread({}, state.searchResult), {}, {
        [state.selectSiteKindCd]: _objectSpread(_objectSpread({}, state.searchResult[state.selectSiteKindCd]), {}, {
          rowList: newRowList
        })
      })
    });
  },
  // ページ変更
  [TYPES.CHANGE_PAGE]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      paging: _objectSpread(_objectSpread({}, state.paging), {}, {
        [state.selectSiteKindCd]: _objectSpread(_objectSpread({}, state.paging[state.selectSiteKindCd]), {}, {
          currentPage: action.payload.currentPage
        })
      })
    });
  },
  // １ページの表示件数を変更
  [TYPES.CHANGE_VIEW_NUM]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    paging: _objectSpread(_objectSpread({}, state.paging), {}, {
      [state.selectSiteKindCd]: {
        currentPage: 0,
        viewNum: action.payload.viewNum
      }
    })
  }),
  // 詳細表示
  [TYPES.CHANGE_SHOW_DETAIL]: (state, action) => {
    let rowList = action.payload.searchResult.rowList;
    let newRowList = JSON.parse(JSON.stringify(rowList)).map(row => {
      return row;
    });
    return _objectSpread(_objectSpread({}, state), {}, {
      showDetail: {
        [state.selectSiteKindCd]: action.payload.showDetail
      },
      searchResult: _objectSpread(_objectSpread({}, state.searchResult), {}, {
        [state.selectSiteKindCd]: _objectSpread(_objectSpread({}, state.searchResult[state.selectSiteKindCd]), {}, {
          rowList: newRowList
        })
      })
    });
  },
  // 初期状態にする
  [TYPES.CLEAR]: () => _objectSpread({}, INIT_STATE)
}, INIT_STATE);